import { useEffect } from 'react';
import { setSuperProperties, setSuperPropertiesOnce } from '../utils/analytics';

const isBrowser = typeof window !== 'undefined';

function getUtmParams(): Record<string, string> {
  if (!isBrowser) return {};
  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
    const val = params.get(key);
    if (val) utm[key] = val;
  }
  return utm;
}

export function useTrackingInit() {
  useEffect(() => {
    // First-touch attribution (set once, never overwritten)
    setSuperPropertiesOnce({
      first_landing_page: window.location.pathname,
      first_referrer: document.referrer || '$direct',
      ...Object.fromEntries(
        Object.entries(getUtmParams()).map(([k, v]) => [`first_${k}`, v]),
      ),
    });

    // Last-touch UTM params (overwritten each session)
    const utms = getUtmParams();
    if (Object.keys(utms).length > 0) {
      setSuperProperties(utms);
    }
  }, []);
}
